import React from 'react'
import RadioGroup from './RadioGroup'

type PropTypes = {
  name: string
  value: boolean | undefined
  onComplete: (update: boolean) => void
}

export const CapacityForm = ({ name, onComplete, value }: PropTypes) => (
  <div className="signature-modal-vertial-center">
    <div>
      <p
        style={{
          transition: 'all 0.2s',
          fontWeight: 700,
          fontSize: 16,
        }}
      >
        Does {name} have Capacity to give Consent?
      </p>
      <RadioGroup
        // @ts-ignore
        onChange={onComplete}
        value={value}
        options={[
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ]}
      />
    </div>
  </div>
)

export default CapacityForm
